export default __webpack_public_path__ + "static/media/login_image.fc851658.jpg";